import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { auth } from "../../firebaseConfig";

export const readDataS6 = async () => {
  const user = auth.currentUser;
  try {
    const docRef = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Business Conduct"
    );
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data(); // Return the form data
    } else {
      // console.log("No such document for Section 6!");
      return null;
    }
  } catch (error) {
    // console.error("Error fetching Section 6 data: ", error);
  }
};
